import React from "react";
import styled from "styled-components";

const DEFAULT_MARGIN_TOP = "80px";
const DEFAULT_MARGIN_BOTTOM = "40px";

const LogoContainer = styled.img`
  margin: ${(props) => props.marginTop} auto ${(props) => props.marginBottom};
  width: 180px;
  height: 36px;
  object-fit: contain;
`;

const LOGO_SRC_BY_TYPE = {
  light: "/static/images/logo.png",
  white: "/static/images/logo-white.png",
  dark: "/static/images/logo-dark.png"
};

export const Logo = ({ marginTop, type, marginBottom, ...other }) => (
  <LogoContainer
    {...other}
    marginTop={marginTop}
    marginBottom={marginBottom}
    src={LOGO_SRC_BY_TYPE[type]}
  />
);

Logo.defaultProps = {
  type: "light",
  marginTop: DEFAULT_MARGIN_TOP,
  marginBottom: DEFAULT_MARGIN_BOTTOM
};

